import React from 'react';
import { Row } from 'antd';
import type { RowProps } from 'antd';

export type AppRowProps = RowProps;

const AppRow = React.forwardRef<HTMLDivElement, AppRowProps>((props, ref) => {
  return <Row ref={ref} {...props} />;
});

AppRow.displayName = 'AppRow';

export default AppRow;
